import { observer } from 'mobx-react';

import { useStores } from '../../../../stores/useStores';
import type { BingoWidgetDataType, WidgetSizeType } from '../../types';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { BingoSmallWidget } from './BingoSmallWidget/BingoSmallWidget';
import { BingoWideWidget } from './BingoWideWidget/BingoWideWidget';
import styles from './BingoWidget.module.scss';

interface BingoWidgetProps {
  sizeType: WidgetSizeType;
  data: BingoWidgetDataType;
}

function BingoWidgetComponent(props: BingoWidgetProps) {
  const { data, sizeType } = props;
  const { widgetType } = data;
  const timerIncluded = widgetType === 'upcoming' || widgetType === 'live';
  const { bingoStore } = useStores();
  const isNewPlayer = !bingoStore.hasEverParticipatedInBingo;

  return (
    <WidgetWrapper className={styles.container} sizeType={sizeType} smallWidgetExtended={timerIncluded}>
      {sizeType === 'small' ? (
        <BingoSmallWidget data={data} newPlayer={isNewPlayer} />
      ) : (
        <BingoWideWidget data={data} newPlayer={isNewPlayer} widgetType={widgetType} />
      )}
    </WidgetWrapper>
  );
}

export const BingoWidget = observer(BingoWidgetComponent);
